import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';


// Context
import { InitiaContextProvider } from './context/initia-context';

ReactDOM.render(<InitiaContextProvider><App /></InitiaContextProvider>, document.getElementById('root'));
